module.exports = __webpack_public_path__ + "img/Platform_Gradients-7.af34b3a5.jpg";